import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import GlDateManager from '../../../share/GlDateManager'
import GlLegalText from '../../../share/GlLegalText'
import ShareAnalyticDetailsAuthorMirrorConstellationCard from './ShareAnalyticDetailsAuthorMirrorConstellationCard'
import ShareAnalyticDetailsAuthorMirrorList from './ShareAnalyticDetailsAuthorMirrorList'
import {
  selectAnaliticDetailsStateAuthorDetails,
  selectAnalyticDetailsStateAnalyticDetails,
  selectAnalyticDetailsStateWorkMirrorBookDetailsCardValues,
} from '../../../../store/getters/analytics-details/analytic-details-v2.getters'
import AuthorMirrorAuthorDetailsCard from '../../../analytics-details-v2/view/author-mirror/AuthorMirrorAuthorDetailsCard'
import {
  analyticDetailsV2StateGetAuthorDetailsData,
  analyticDetailsV2StateGetBookDetailsData,
} from '../../../../store/actions/analytics-details/analytic-details-v2.actions'
import { WorkMirrorBookInterface } from '../../../../core/interface/report/work-mirror-book.interface'
import { AuthorMirrorAuthorInterface } from '../../../../core/interface/report/author-mirror-author.interface'
import WorkMirrorBookDetailsCard from '../../../analytics-details-v2/view/work-mirror/WorkMirrorBookDetailsCard'

const ShareAnalyticDetailsAuthorMirrorView = () => {
  const { t } = useTranslation()
  const [openListCard, setOpenListCard] = useState<boolean>(false)

  const dispatch = useAppDispatch()

  const analyticsDetails = useAppSelector(
    selectAnalyticDetailsStateAnalyticDetails,
  )

  const {
    isLoadingBookDetailsGetBookReco,
    bookDetailsBookReco,
    isLoadingGetBookDetails,
    isLoadingGetEditions,
    isLoadingGetB2BBookDetails,
    bookDetailsSelected,
    bookDetailsSelectedEditions,
    bookDetailsSelectedB2BInfo,
  } = useAppSelector(selectAnalyticDetailsStateWorkMirrorBookDetailsCardValues)

  const { authorDetailsAuthorReco, authorDetailsSelected } = useAppSelector(
    selectAnaliticDetailsStateAuthorDetails,
  )

  const handleOpenListView = () => {
    setOpenListCard(!openListCard)
  }

  const handleCloseList = () => {
    setOpenListCard(false)
  }

  const handleCloseAuthorDetails = useCallback(() => {
    void dispatch(
      analyticDetailsV2StateGetAuthorDetailsData({ authorDetails: null }),
    )
  }, [authorDetailsSelected])

  const handleCloseBookDetails = useCallback(() => {
    void dispatch(
      analyticDetailsV2StateGetBookDetailsData({ bookDetails: null }),
    )
  }, [bookDetailsSelected])

  const handleAuthorSelected = useCallback(
    (authorDetails: AuthorMirrorAuthorInterface | null) => {
      if (!authorDetails) {
        return
      }

      void dispatch(
        analyticDetailsV2StateGetAuthorDetailsData({ authorDetails }),
      )

      handleCloseBookDetails()
    },
    [authorDetailsSelected],
  )

  const handleBookSelected = useCallback(
    (bookDetails: WorkMirrorBookInterface | null) => {
      void dispatch(analyticDetailsV2StateGetBookDetailsData({ bookDetails }))
      handleCloseAuthorDetails()
    },
    [
      bookDetailsSelected,
      bookDetailsSelectedEditions,
      bookDetailsSelectedB2BInfo,
    ],
  )

  const [authorIdHovered, setAuthorIdHovered] = useState<string | null>(null)
  const handleAuthorHovered = useCallback(
    (authorId: string | null) => {
      setAuthorIdHovered(authorId)
    },
    [authorIdHovered],
  )

  return (
    <div className="flex-auto flex flex-col p-8 gap-2">
      <GlDateManager
        prefix={t('ReportReaderShipProfileDate')}
        date={analyticsDetails.modified}
      />
      <div className="flex-auto flex flex-row gap-2">
        <ShareAnalyticDetailsAuthorMirrorConstellationCard
          openListCard={openListCard}
          handleOpenListView={handleOpenListView}
          handleAuthorHovered={handleAuthorHovered}
        />
        {authorDetailsSelected && (
          <AuthorMirrorAuthorDetailsCard
            handleAuthorSelected={handleAuthorSelected}
            handleBookSelected={handleBookSelected}
            authorDetailsAuthorReco={authorDetailsAuthorReco}
            openListCard={openListCard}
            authorDetailsSelected={authorDetailsSelected}
            handleCloseAuthorDetails={handleCloseAuthorDetails}
          />
        )}

        {bookDetailsSelected && (
          <WorkMirrorBookDetailsCard
            isLoadingBookDetailsGetBookReco={isLoadingBookDetailsGetBookReco}
            bookDetailsBookReco={bookDetailsBookReco}
            isLoadingGetBookDetails={isLoadingGetBookDetails}
            isLoadingGetEditions={isLoadingGetEditions}
            isLoadingGetB2BBookDetails={isLoadingGetB2BBookDetails}
            openListCard={openListCard}
            bookDetails={bookDetailsSelected}
            bookDetailsSelectedEditions={bookDetailsSelectedEditions}
            bookDetailsSelectedB2BInfo={bookDetailsSelectedB2BInfo}
            handleCloseBookDetails={handleCloseBookDetails}
          />
        )}

        {!bookDetailsSelected && !authorDetailsSelected && openListCard && (
          <ShareAnalyticDetailsAuthorMirrorList
            authorIdHovered={authorIdHovered}
            handleCloseList={handleCloseList}
          />
        )}
      </div>
      <GlLegalText />
    </div>
  )
}

export default ShareAnalyticDetailsAuthorMirrorView
